import { Api, loggingCatchBlockMessage } from 'src/common';
import { Environment } from 'src/Environment';
import { Application } from 'src/features/common';
import { LoggingService } from 'src/features/common/services/logging-service';
import { getBrowserName, getOSName } from 'src/helpers/browser';
import { getCurrentStep, getLoggingTraceId } from 'src/helpers/logging';
import { getJourneyNameFromSessionStorage } from 'src/utils/SessionStorage/GetJourneyNameFromSessionStorage';

const endpoint = `signedMerchantAgreements`;

type SignedMerchantAgreement = {
  signedAgreement: string;
};

export async function requestSignedMerchantAgreement(
  application: Application,
  base64Image: string,
): Promise<{ error?: string; signedAgreementPDF?: string }> {
  const loggingService = new LoggingService();

  const startTime = performance.now();
  try {
    const { response, status, url } = await Api.post<SignedMerchantAgreement>(endpoint, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ signatureCapture: base64Image }),
    });

    loggingService.info({
      traceId: getLoggingTraceId(),
      solutionType: application.solutionType,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: getCurrentStep(application.steps, application.currentStepIndex),
      referenceNumber: application.referenceNumber,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: status,
        endpoint: url,
        responseBody: response,
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
    });

    return { signedAgreementPDF: response.signedAgreement };
  } catch (error) {
    loggingService.error({
      message: loggingCatchBlockMessage,
      traceId: getLoggingTraceId(),
      solutionType: application.solutionType,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: getCurrentStep(application.steps, application.currentStepIndex),
      referenceNumber: application.referenceNumber,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: 500,
        endpoint: `${Environment.current.apiHost}${Environment.current.apiBase}${endpoint}`,
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
    });

    return { error: 'An error occurred while processing your request.' };
  }
}
